
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Tabs } from "@/components/ui/tabs";
import { HelpCircle } from "lucide-react";
import { Button } from '@/components/ui/button';
import HelpGuideContent from './HelpGuideContent';

interface HelpGuideProps {
  trigger?: React.ReactNode;
}

const HelpGuide: React.FC<HelpGuideProps> = ({ 
  trigger = (
    <Button size="sm" variant="outline">
      <HelpCircle className="mr-2 h-4 w-4" />
      Help
    </Button>
  ) 
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto p-0">
        <DialogHeader className="p-6 pb-2 sticky top-0 bg-background z-10">
          <DialogTitle>Bitcoin Mining Career Simulator Guide</DialogTitle>
          <DialogDescription>
            Learn how to navigate your career in the Bitcoin mining industry
          </DialogDescription>
        </DialogHeader>
        
        <Tabs defaultValue="basics" className="px-6 pb-6">
          <HelpGuideContent />
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default HelpGuide;
